import React, {useState} from "react";
import {validateCoupon} from "../util/APIHelper";
import {ICONS} from "../components/generic/BCIcons";
import {BCIcon} from "./generic/BCIcons";
import {FlexRow} from "./generic/Containers";

interface UpdatedPricingOption {
    cssId: string;
    interval: string;
    price: number;
    recommended: boolean;
    stripeId: string;
    title: string;
}

interface CouponResponse {
    coupon: string;
    isValid: boolean;
    updatedPricingOptions?: UpdatedPricingOption[];
}

export const CouponContainer: React.FC<{
    setApprovedCouponCode: (code: string) => void;
    onPricingOptionsUpdate?: (options: UpdatedPricingOption[]) => void;
}> = ({setApprovedCouponCode, onPricingOptionsUpdate}) => {
    const [showCouponCode, setShowCouponCode] = React.useState(false);
    const [couponCode, setCouponCode] = useState("");
    const [couponText, setCouponText] = React.useState("");
    const [couponStatus, setCouponStatus] = React.useState<"idle" | "loading" | "success" | "error">("idle");

    const checkCoupon = () => {
        setCouponText("Loading...")
        setCouponStatus("loading")
        validateCoupon(couponCode.toUpperCase()).then(response => {
            if (response && response.data) {
                const data: CouponResponse = response.data;
                if (data.isValid) {
                    setCouponText("Coupon Applied!")
                    setCouponStatus("success")
                    setApprovedCouponCode(data.coupon)
                    setShowCouponCode(false)
                    
                    // If we have updated pricing options, pass them to the parent
                    if (data.updatedPricingOptions && onPricingOptionsUpdate) {
                        onPricingOptionsUpdate(data.updatedPricingOptions);
                    }
                } else {
                    setShowCouponCode(false)
                    setCouponText("Coupon Invalid")
                    setCouponStatus("error")
                }
            } else {
                setCouponText("Coupon Invalid")
                setCouponStatus("error")
            }
        }).catch(error => {
            console.error("Error validating coupon:", error);
            setCouponText("Error validating coupon")
            setCouponStatus("error")
        })
    }

    const haveCouponClicked = () => {
        setShowCouponCode(true)
        setCouponText('')
    }
    
    return (
        <div className={'coupon-container'}>
            <FlexRow gap={1}>
                {!showCouponCode && <div className={'coupon-question-text'} onClick={() => haveCouponClicked()}>Have a Coupon?</div>}
                {showCouponCode &&
                    <FlexRow>
                        <input
                            className={'coupon-code-input'}
                            maxLength={20}
                            onChange={(e) => setCouponCode(e.target.value)}
                            onKeyPress={(e) => e.key === 'Enter' && checkCoupon()}
                        />
                        <div className={'coupon-submit-right-arrow-container'} onClick={() => checkCoupon()}>
                            <BCIcon icon={ICONS.RIGHT_ARROW} className={'coupon-submit-right-arrow'} />
                        </div>
                    </FlexRow>
                }
                {couponText && (
                    <div className={`coupon-code-text ${couponStatus}`}>
                        {couponText}
                    </div>
                )}
            </FlexRow>
        </div>
    )}